export default __webpack_public_path__ + "static/media/logo--image.2aaac773.png";